import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { applicationUrl } from "@constants";

export const IDENTIFICATION_FILES_NON_USER_API_KEY = "identificationFilesNoneUserApi";
export const identificationFilesNonUserApi = createApi({
  reducerPath: IDENTIFICATION_FILES_NON_USER_API_KEY,
  baseQuery: fetchBaseQuery({ baseUrl: applicationUrl }),
  endpoints: (builder) => ({
    postIdentificationFileNonUser: builder.mutation<void, FormData>({
      query: (formData) => ({
        url: "/api/identificationFile",
        method: "POST",
        body: formData,
        responseHandler: "text",
      }),
    }),
  }),
});

export const { usePostIdentificationFileNonUserMutation } = identificationFilesNonUserApi;
